package io.horion.cv.models

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class ListState(
    val id: String,
    val sectionId: String,
    title: String = ""
) {
    var title by mutableStateOf(title)
}